"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
function NewsArticleConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="w-full overflow-hidden rounded-lg shadow-md">
          <AspectRatio ratio={4 / 3} className="bg-muted animate-pulse" />
        </div>
        <div className="flex flex-col space-y-4">
          <div className="h-10 w-3/4 rounded-md bg-muted animate-pulse" />
          <div className="h-4 w-full rounded-md bg-muted animate-pulse" />
          <div className="h-4 w-5/6 rounded-md bg-muted animate-pulse" />
          <div className="h-4 w-4/6 rounded-md bg-muted animate-pulse" />
          <div className="mt-4 h-12 w-32 rounded-md bg-muted animate-pulse" />
        </div>
      </div>;
  }
  if (error || !posts || posts.length === 0) {
    return null;
  }
  const post = posts[0];
  return <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
      <div className="relative w-full overflow-hidden rounded-lg shadow-lg">
        <AspectRatio ratio={4 / 3}>
          {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover" loading="lazy" /> : <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sucursal_expres_mazatlan.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sucursal_expres_mazatlan.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sucursal_expres_mazatlan.png-wvc-sizes" alt={post.title || "Sucursal exprés; Mazatlán Delfín"} className="h-full w-full object-cover" loading="lazy" />}
        </AspectRatio>
      </div>
      
      <div className="flex flex-col items-start">
        <h3 className="mb-4 font-default text-3xl font-bold leading-tight text-foreground md:text-4xl">
          {post.title || "Sucursal exprés; Mazatlán Delfín"}
        </h3>
        
        {post.excerpt ? <div className="mb-8 line-clamp-3 text-lg text-muted-foreground" dangerouslySetInnerHTML={{
        __html: post.excerpt
      }} /> : <p className="mb-8 text-lg text-muted-foreground">
            Descubre las últimas novedades y actualizaciones sobre nuestra nueva sucursal exprés en Mazatlán Delfín. Conoce más detalles sobre nuestros servicios, horarios de atención y cómo estamos más cerca de ti para brindarte el mejor servicio.
          </p>}
        
        <Link to={post.link || "#"}>
          <Button size="lg" className="font-semibold shadow-md">
            Ver noticia
          </Button>
        </Link>
      </div>
    </div>;
}
export default function NewsUpdates() {
  const wp_query_params = {
    post_type: "post",
    per_page: 1
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="news-updates" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-3xl font-bold text-foreground mb-8 md:text-4xl">Noticias</h2>
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 1
      }}>
          <NewsArticleConsumer />
        </PostsProvider>
      </div>
    </section>;
}